/**
 * 提供表单布局,搜索重置功能(可选)
 * @param layout?: 每行展示几列 默认为3
 * @param labelCol?: 同Form.Item, label占比 默认为6
 * @param wrapperCol?: 同Form.Item, 表单项占比 默认为16
 * @param form?: 表单API，为组件使用时的this.props.form 需要按钮操作Form时必填
 * @param onSearch?:(formData)=>{} 点击搜索的回调函数 formData为表单数据
 * */
import React, { Component } from 'react';
import { Form, Col, Button } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import { getDataType } from '@/shared/functions';
import { RowCol } from '@/components';
const Root = styled.div `
  padding: 20px;
  background: #F7F7F7;
  border-radius: 5px;
  .search-btn{
    margin-left: 12px;
  }
`;
class FormLayout extends Component {
    formControl(span, offset = 0) {
        return (<Col span={span} style={{
            display: 'flex',
            justifyContent: 'flex-end',
        }}>
        <Button className="reset-btn" onClick={() => {
            this.reset();
        }}>
          重置
        </Button>
        <Button type={'primary'} className="search-btn" onClick={() => {
            this.search();
        }}>
          搜索
        </Button>
      </Col>);
    }
    search(isReset = false) {
        if (!this.props.form) {
            console.warn('form为必填参数，请检查配置');
            return false;
        }
        this.props.form.validateFields()
            .then((formData) => {
            const date = formData;
            const dateTime = Object.assign({}, formData);
            Object.keys(formData)
                .forEach((v, i) => {
                const formItem = formData[v];
                if (getDataType(formItem) === 'Array') {
                    date[v] = formItem.map((time) => {
                        return this.dealTime(time, 'YYYY-MM-DD');
                    });
                    dateTime[v] = formItem.map((time) => {
                        return this.dealTime(time, 'YYYY-MM-DD HH:MM:SS');
                    });
                }
                if (formItem instanceof moment) {
                    // @ts-ignore
                    date[v] = formItem.format('YYYY-MM-DD');
                    // @ts-ignore
                    dateTime[v] = formItem.format('YYYY-MM-DD HH:MM:SS');
                }
            });
            this.props.onSearch && this.props.onSearch(date, dateTime, isReset);
        });
    }
    dealTime(time, formatStyle) {
        let delTime = time;
        if (time instanceof moment) {
            // @ts-ignore
            delTime = time.format(formatStyle);
        }
        return delTime;
    }
    reset() {
        if (!this.props.form) {
            console.warn('form为必填参数，请检查配置');
            return false;
        }
        this.props.form.resetFields();
        this.search(true);
    }
    render() {
        const { labelCol, wrapperCol, colon, layout, labelAlign } = this.props;
        return (<Root>
        <Form labelCol={{ span: labelCol }} wrapperCol={{ span: wrapperCol }} colon={colon} autoComplete="off" labelAlign={labelAlign}>
          <RowCol layout={layout} floatChild={this.formControl(24 / layout)}>
            {this.props.children}
          </RowCol>
        </Form>
      </Root>);
    }
}
FormLayout.defaultProps = {
    layout: 3,
    labelCol: 8,
    wrapperCol: 16,
    colon: true,
    backColor: '#F7F7F7',
    labelAlign: 'right',
};
export default FormLayout;
